import styled from 'styled-components'

// Added to prevent too large gaps in lists
// When there were line breaks in the original source
export const Content = styled.div`
  div {
    white-space: normal;
  }
`
